import { useEffect } from 'react';

/**
 * この画面を検索インデックスの対象外にする。
 *
 * /g/ 配下はグループトークンが無いと中身が出ない。外部から素で開けば必ず
 * 認証エラー画面になるので、それが検索結果に並ぶとドメイン全体の評価に響く。
 * トークンはフラグメント #t=… にあってサーバーには送られないため、データが
 * 漏れるわけではない。塞ぐのは中身ではなく空の画面の露出。
 *
 * robots.txt の Disallow は使えない。取得自体を止めると noindex を読ませる
 * こともできず、外部リンク経由で「URLだけ」が検索結果に居座り続ける。
 *
 * canonical を外しているのは、noindex と併用すると危ないため。noindex の
 * ページからトップへ canonical を向けると、Google が両者の評価をまとめる
 * 過程で noindex までトップ側に適用しうる。index.html の canonical は静的に
 * 入っているので、ここで取り除いて離脱時に戻す。
 */
export function useNoIndex() {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);

    // 戻す前提で参照を掴んでおく。StrictMode は effect を2回走らせるので、
    // 復元しないと2回目の querySelector が空振りして canonical が消えたままになる。
    const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    canonical?.remove();

    return () => {
      meta.remove();
      if (canonical) document.head.appendChild(canonical);
    };
  }, []);
}
